import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

// TODO: merge `d` attribute into one for 16px
const draw24px =
  'M10,8h7.43L15.57,5.82a.75.75,0,0,1,.08-1.06.76.76,0,0,1,1.06.08l2.88,3.37a.74.74,0,0,1,0,1l-2.88,3.37a.76.76,0,0,1-.57.26.75.75,0,0,1-.57-1.24l1.82-2.12H10a4.24,4.24,0,0,0,0,8.48h7.6a.75.75,0,0,1,0,1.5H10A5.74,5.74,0,0,1,10,8Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const RedoIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'redo'),
) as IconWithRender;

RedoIcon.displayName = 'RedoIcon';
RedoIcon.propTypes = Icon.propTypes;
RedoIcon.renderIcon = (props) => <RedoIcon {...props} />;
export default RedoIcon;
